import type { AiSuggestionDetail } from "../types/aiSuggestion";

export type ClauseTriple = {
  readonly showOriginal: boolean;
  readonly originalClause: string | null;
  readonly clientRecommended: string | null;
  readonly aiRecommended: string | null;
};

/**
 * Maps API fields to Original / Client / AI cards (matches backend persisted rows):
 * If `client_suggested_text` is set: original = `original_text` (pre–track baseline), client = manifest, AI = `ai_suggested_text`.
 * Else: hide original, client = `original_text`, AI = `ai_suggested_text`.
 */
export const clauseTripleFromSuggestion = (
  s: AiSuggestionDetail,
): ClauseTriple => {
  const client = s.client_suggested_text;
  console.log(s);
  const hasClient = client != null && client.trim() !== "";
  if (hasClient) {
    return {
      showOriginal: true,
      originalClause: s.original_text,
      clientRecommended: client,
      aiRecommended: s.ai_suggested_text,
    };
  }
  return {
    showOriginal: true,
    originalClause: s.original_text,
    clientRecommended: client,
    aiRecommended: s.ai_suggested_text,
  };
};
